export const _en = {
    name: {
        label: "Name"
    },
    description: {
        label: "Description"
    },
    startTime: {
        label: "Start time"
    },
    finishTime: {
        label: "Finish time"
    },
    lunchDuration: {
        label: "Lunch duration"
    },
    vacationDuration: {
        label: "Vacation duration"
    },
    refDivisionId: {
        label: "Division"
    }
};

export const _fr = {
    name: {
        label: "Nom"
    },
    description: {
        label: "Description"
    },
    startTime: {
        label: "Heure de début"
    },
    finishTime: {
        label: "Heure de fin"
    },
    lunchDuration: {
        label: "Durée de la pause déjeuner"
    },
    startPauseMeridian: {
        label: "Début plage méridienne"
    },
    finishPauseMeridian: {
        label: "Fin plage méridienne"
    },
    vacationDuration: {
        label: "Amplitude horaire"
    },
    color: {
        label: "Couleur"
    },
    refDivisionId: {
        label: "Service"
    }
};